<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.p1 | mailgunMarkAsHtml" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.p2" presetName="paragraph" />

    <ng-container *mailgunIf="data.button_link">
      <email-margin [height]="28" />
      <email-button [href]="data.button_link" [label]="data.button_text" theme="primary" />
    </ng-container>
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
